import React from 'react';
import { BarChart3Icon, WalletIcon, UsersIcon, TagIcon } from 'lucide-react';
interface KPIData {
  totalCampaigns: number;
  budget: string;
  leads: string;
  costPerLead: string;
}
interface KPICardsProps {
  data: KPIData;
}
export function KPICards({
  data
}: KPICardsProps) {
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-72">
      {/* Primary Card */}
      <div className="bg-primary text-primary-foreground rounded-2xl p-6 shadow-sm flex flex-col justify-between gap-4 h-full" data-id="element-73">
        <div className="flex items-center justify-between" data-id="element-74">
          <span className="text-sm font-medium text-primary-foreground/80" data-id="element-75">
            Total campaigns
          </span>
          <div className="p-2.5 bg-primary-foreground/10 rounded-xl" data-id="element-76">
            <BarChart3Icon className="w-5 h-5 text-primary-foreground" data-id="element-77" />
          </div>
        </div>
        <span className="text-3xl font-bold block" data-id="element-78">{data.totalCampaigns}</span>
      </div>

      {/* Secondary Cards */}
      <div className="bg-card border border-border rounded-2xl p-6 shadow-sm flex flex-col justify-between gap-4 h-full" data-id="element-79">
        <div className="flex items-center justify-between" data-id="element-80">
          <span className="text-sm font-medium text-muted-foreground" data-id="element-81">
            Budget
          </span>
          <div className="p-2.5 bg-muted rounded-xl" data-id="element-82">
            <WalletIcon className="w-5 h-5 text-foreground" data-id="element-83" />
          </div>
        </div>
        <span className="text-3xl font-bold text-foreground block" data-id="element-84">
          {data.budget}
        </span>
      </div>

      <div className="bg-card border border-border rounded-2xl p-6 shadow-sm flex flex-col justify-between gap-4 h-full" data-id="element-85">
        <div className="flex items-center justify-between" data-id="element-86">
          <span className="text-sm font-medium text-muted-foreground" data-id="element-87">
            Leads
          </span>
          <div className="p-2.5 bg-muted rounded-xl" data-id="element-88">
            <UsersIcon className="w-5 h-5 text-foreground" data-id="element-89" />
          </div>
        </div>
        <span className="text-3xl font-bold text-foreground block" data-id="element-90">
          {data.leads}
        </span>
      </div>

      <div className="bg-card border border-border rounded-2xl p-6 shadow-sm flex flex-col justify-between gap-4 h-full" data-id="element-91">
        <div className="flex items-center justify-between" data-id="element-92">
          <span className="text-sm font-medium text-muted-foreground" data-id="element-93">
            Cost per lead
          </span>
          <div className="p-2.5 bg-muted rounded-xl" data-id="element-94">
            <TagIcon className="w-5 h-5 text-foreground" data-id="element-95" />
          </div>
        </div>
        <span className="text-3xl font-bold text-foreground block" data-id="element-96">
          {data.costPerLead}
        </span>
      </div>
    </div>;
}